import { App as CapApp } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { isNativeApp } from '../utils/platform';

export async function initNativeApp() {
  if (!isNativeApp()) return;

  document.documentElement.classList.add('gadkot-native-app');
  document.body.classList.add('gadkot-native-app');

  try {
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#2a1810' });
  } catch {
    // plugin optional
  }

  try {
    CapApp.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        CapApp.exitApp();
      }
    });
  } catch {
    // ignore
  }
}
